import React from "react";
import { Text } from "@chakra-ui/react";

export const CandleSafety: React.FC = () => {
  return (
    <Text variant="acuminLight" mt={{ base: 0, lg: 1 }}>
      Never leave a burning candle unattended and always burn out of reach of
      children and pets. Do not burn a candle on or near anything that can catch
      fire. Always place your candle on a heat resistant, non-flammable surface
      that’s on an even level. It's advised to choose an area free from drafts
      to avoid uneven burning. If the base of the hot candle comes into contact
      with a cold material, the glass may crack due to the dramatic temperature
      change. Our candles fully comply with safety standards and we continue to
      remain confident in their quality with these advised care instructions.
    </Text>
  );
};
